import _ from 'lodash';
import React, { useCallback } from 'react';
import { useModal } from '@jutro/components';
import { messages as commonMessages } from '@xengage/gw-platform-translations';
import { Redirect } from 'react-router-dom';
import PECodegenWizardMessages from '../PECodegenWizard.messages';

const useWizardError = ({ location, setHasErrorOccurred }) => {
    const { showAlert } = useModal();
    const handleError = useCallback(
        (error) => {
            const isQuotePage = _.includes(_.toLower(_.get(error, 'gwInfo.method')), 'quote');
            const quoteIDFromWizard = _.get(error, 'gwInfo.params[0].quoteID');
            const quoteIDFromLocation = _.get(location, 'state.quoteentry.quoteID');
            const quoteID = quoteIDFromWizard || quoteIDFromLocation;
            const redirectPath = `/quotes/${quoteID}/summary`;
            const state = {
                pathname: redirectPath,
                state: error
            };


            return showAlert({
                title: isQuotePage
                    ? PECodegenWizardMessages.saveQuoteError
                    : PECodegenWizardMessages.anErrorOccurredTitle,
                message: isQuotePage
                    ? PECodegenWizardMessages.saveQuoteErrorMessage
                    : PECodegenWizardMessages.anErrorOccurred,
                status: 'error',
                icon: 'mi-error-outline',
                confirmButtonText: commonMessages.ok
            }).then(() => {
                setHasErrorOccurred(true);
                return <Redirect to={state} />;
            }, _.noop);
        },
        [location, setHasErrorOccurred]
    );

    return handleError;
};

export default useWizardError;